import { render, staticRenderFns } from "./ControlStrategyHuman.vue?vue&type=template&id=1c18ab76&scoped=true&"
import script from "./ControlStrategyHuman.vue?vue&type=script&lang=js&"
export * from "./ControlStrategyHuman.vue?vue&type=script&lang=js&"
import style0 from "./ControlStrategyHuman.vue?vue&type=style&index=0&id=1c18ab76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c18ab76",
  null
  
)

export default component.exports